import type React from 'react';
import styles from './tabs.module.scss';
import { panelId, tabId, useWordsHappenTabsContext } from './tabs-context';

export interface WordsHappenTabPanelProps {
  children?: React.ReactNode;
  className?: string;
  /** Matches the WordsHappenTab that shows it. */
  value: string;
}

/** The content for one tab, labelled by it. Hidden while another tab is selected; its children render only when shown. */
export const WordsHappenTabPanel: React.FC<WordsHappenTabPanelProps> = ({ children, className, value }) => {
  const { activeValue, baseId } = useWordsHappenTabsContext();
  const active = activeValue === value;

  return (
    <div
      role="tabpanel"
      id={panelId(baseId, value)}
      aria-labelledby={tabId(baseId, value)}
      hidden={!active}
      className={[styles.tabPanel, className].filter(Boolean).join(' ')}
    >
      {active ? children : null}
    </div>
  );
};
